import { Modal } from "antd";
import FormExportacaoContabil from "./../FormExportacaoContabil/index";
import { useForm } from "react-hook-form";
import { useState, useEffect } from "react";
import FooterModal from "ui/components/Button/FooterModal";
import useExportacaoContabil from "core/features/exportacao-contabil/hooks/useExportacaoContabil";
import {
  FiltroExportacaoContabil,
  ExportacaoContabilForm,
} from "features/exportacao-contabil/typings";
import { useLoading } from "ui/components/GlobalLoading/index";

interface ModalExportacaoContabilProps {
  visible: boolean;
  onClose: () => any;
  filtro: FiltroExportacaoContabil;
}

export default function ModalExportacaoContabil({
  onClose,
  visible,
  filtro,
}: ModalExportacaoContabilProps) {
  const { data, isLoading, isFetching } = useExportacaoContabil(filtro);

  const [currentStep, setCurrentStep] = useState(0);

  const { control, handleSubmit, watch, reset, setValue } =
    useForm<ExportacaoContabilForm>({
      defaultValues: {
        contasBancarias: [],
      },
    });

  useEffect(() => {
    if (data) {
      reset({
        contasBancarias: data.contasBancarias.map((conta) => ({
          id: conta.id,
          codigoIntegracao: conta.codigoIntegracao ?? undefined,
          selected: false,
          nome: conta.nome,
        })),
        receitas: data.receitas.map((receita) => ({
          categoriaFinanceiraId: receita.id,
          codigoIntegracao: receita.codigoIntegracao ?? undefined,
          pessoas: receita.pessoas.map((pessoa) => ({
            id: pessoa.id,
            codigoIntegracao: pessoa.codigoIntegracao ?? undefined,
          })),
        })),
        despesas: data.despesas.map((despesas) => ({
          categoriaFinanceiraId: despesas.id,
          codigoIntegracao: despesas.codigoIntegracao ?? undefined,
          pessoas: despesas.pessoas.map((pessoa) => ({
            id: pessoa.id,
            codigoIntegracao: pessoa.codigoIntegracao ?? undefined,
          })),
        })),
        transferencias: data.transferencias,
      });
    }
  }, [data, reset]);

  const form = watch();

  const maxStep = 5;

  const onSubmit = async (form: ExportacaoContabilForm) => {
    console.log(form);
  };

  const handleSave = () => handleSubmit(onSubmit)();

  const onNext = () => {
    if (currentStep < maxStep) {
      setCurrentStep(Math.min(currentStep + 1, maxStep));
    }
  };

  const onPrev = () => {
    if (currentStep === 0) {
      onClose();
    } else {
      setCurrentStep(Math.max(currentStep - 1, 0));
    }
  };

  useLoading(isLoading);
  return (
    <Modal
      destroyOnClose
      width="1400px"
      footer={
        <FooterModal
          showBorderTop={false}
          onSubmit={() => {
            onNext();
          }}
          onClose={() => {
            onPrev();
          }}
          showRegisterAnother={false}
          hidePrimaryButton={currentStep === maxStep}
          primaryButtonText={currentStep < maxStep ? "Avançar" : "Salvar"}
          buttonCancelarText={currentStep === 0 ? "Fechar" : "Voltar"}
        />
      }
      visible={visible}
      onCancel={onClose}
      closable={false}
    >
      <FormExportacaoContabil
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        control={control}
        form={form}
        data={data}
        filtro={filtro}
        setValue={setValue}
        handleSave={handleSave}
        loading={isLoading || isFetching}
      />
    </Modal>
  );
}
